export default {"src":"/_next/static/media/0x10393c20975cf177a3513071bc110f7962cd67da.632a643e.svg","height":57,"width":57,"blurWidth":0,"blurHeight":0};